<template>
    <FormElement class="BulkImportEnumField" :label-for="id" :label="form.schema.title" :required="required">
        <FormInput :invalid="accessed && hasError" force-error-slot>
            <NewDropdown
                :options="options"
                :selected="currentOption"
                :disabled="disabled"
                label="Select an option"
                @input="onSelect"
                @blur="touch"
                @focus="onFocus"
            />
            <template v-if="accessed && error" #errorMessage>
                {{ error }}
            </template>
        </FormInput>
    </FormElement>
</template>

<script lang="ts">
    import { Component, Watch } from '@evidentid/vue-property-decorator';

    import NewDropdown from '@evidentid/dashboard-commons/components/Dropdown/NewDropdown.vue';
    import { DropdownOption } from '@evidentid/dashboard-commons/components/Dropdown/types';
    import { FormElement, FormInput } from '@evidentid/dashboard-commons/components/Form';
    import AbstractJsonSchemaForm
        from '@evidentid/dashboard-commons/components/JsonSchemaForm/elements/AbstractJsonSchemaForm';
    import { JsonFormBase } from '@evidentid/json-schema/interfaces/JsonForm';
    import { JsonSchemaEnum } from '@evidentid/json-schema/interfaces/JsonSchema';
    import { getEnumLabel } from '@/utils/enum-labels/enumLabels';

    @Component({
        emits: [ 'change', 'input' ],
        components: { NewDropdown, FormElement, FormInput },
        inheritAttrs: false,
    })
    export default class BulkImportEnumField extends AbstractJsonSchemaForm<JsonFormBase<JsonSchemaEnum>, any> {
        private options: DropdownOption[] = [];

        @Watch('form.schema.enum', { immediate: true })
        private onEnumChange(): void {
            this.options = (this.form.schema.enum || []).map((value: any) => ({
                value,
                label: getEnumLabel(this.form.schema, value),
            }));
        }

        private get currentOption(): DropdownOption | null {
            return this.options.find((opt) => opt.value === this.value) ?? null;
        }

        private onSelect(option: DropdownOption | null): void {
            if (!option) {
                return;
            }
            this.$emit('input', option.value);
            this.$emit('change', option.value);
        }
    }
</script>
